import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Questions({ form, currentQuestionIndex, selectedAnswer, onSelectAnswer, onNavigate, isSubmitting, onReturnToPersonal }) {
  const [hasSavedData, setHasSavedData] = useState(false);

  useEffect(() => {
    // Verificar si hay datos guardados en localStorage
    const savedPersonalData = localStorage.getItem('personalData');
    const savedAnswers = localStorage.getItem('formAnswers');
    const savedQuestionIndex = localStorage.getItem('currentQuestionIndex');

    if (savedPersonalData || savedAnswers || savedQuestionIndex) {
      setHasSavedData(true);
    }
  }, []);

  if (!form || !form.questions || !Array.isArray(form.questions) || form.questions.length === 0) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{
          background: 'linear-gradient(135deg, #f4f7fc 0%, #e8f0fe 100%)',
          padding: '60px 20px',
        }}
      >
        <div className="min-h-screen flex items-center justify-center" style={{ padding: '20px' }}>
          <p className="text-texto-sec text-center" style={{ fontSize: '1.2rem' }}>
            No hay preguntas disponibles para este formulario.
          </p>
        </div>
      </div>
    );
  }

  const progress = Math.floor((currentQuestionIndex / form.questions.length) * 100);
  const isLastQuestion = currentQuestionIndex >= form.questions.length - 1;

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, #f4f7fc 0%, #e8f0fe 100%)',
        padding: '60px 20px',
      }}
    >
      {/* Contenedor principal */}
      <div className="w-full mx-auto" style={{ maxWidth: '1400px' }}>
        <div
          className="bg-white"
          style={{
            borderRadius: '30px',
            padding: '50px',
            boxShadow: '0 20px 60px rgba(0, 63, 129, 0.15)',
            animation: 'slideUp 0.6s ease-out',
          }}
        >
          {/* Botón para retornar al formulario inicial si hay datos guardados */}
          {hasSavedData && onReturnToPersonal && (
            <div className="flex justify-start" style={{ marginBottom: '25px' }}>
              <button
                className="inline-flex items-center bg-transparent text-icetex font-semibold cursor-pointer uppercase"
                style={{
                  gap: '8px',
                  padding: '12px 24px',
                  border: '2px solid var(--color-azul-icetex)',
                  borderRadius: '25px',
                  fontSize: '14px',
                  letterSpacing: '0.5px',
                  transition: 'all 0.3s ease',
                }}
                onClick={onReturnToPersonal}
                disabled={isSubmitting}
                type="button"
                onMouseEnter={e => {
                  if (!isSubmitting) {
                    e.currentTarget.style.background = 'var(--color-azul-icetex)';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateX(-3px)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 63, 129, 0.2)';
                  }
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                Volver al formulario inicial
              </button>
            </div>
          )}

          {/* Barra de progreso */}
          <div
            style={{
              marginBottom: '40px',
              paddingBottom: '30px',
              borderBottom: '2px solid #e8f0fe',
            }}
          >
            <div className="flex justify-between items-center" style={{ marginBottom: '12px' }}>
              <span
                className="text-texto-sec font-semibold uppercase"
                style={{ fontSize: '14px', letterSpacing: '0.5px' }}
              >
                Progreso del diagnóstico
              </span>
              <span className="text-icetex font-extrabold" style={{ fontSize: '18px' }}>
                {progress}%
              </span>
            </div>
            <div
              className="relative overflow-hidden"
              style={{
                height: '16px',
                backgroundColor: '#e8f0fe',
                borderRadius: '50px',
                boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
              }}
            >
              {/* progress-shimmer is kept — defined in index.css with ::before pseudo-element */}
              <div
                className="progress-shimmer h-full relative overflow-hidden flex items-center justify-end"
                style={{
                  width: `${progress}%`,
                  background: 'linear-gradient(90deg, var(--color-azul-icetex) 0%, #0056b3 100%)',
                  borderRadius: '50px',
                  paddingRight: '12px',
                  transition: 'width 0.5s ease',
                }}
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <span className="text-white relative z-10 font-bold" style={{ fontSize: '11px' }}>
                  {progress}%
                </span>
              </div>
            </div>
            <div
              className="text-center text-texto-oscuro font-bold"
              style={{ marginTop: '10px', fontSize: '14px' }}
            >
              Pregunta {currentQuestionIndex + 1} de {form.questions.length}
            </div>
          </div>

          {/* Pregunta */}
          <div style={{ marginBottom: '35px' }}>
            <div
              className="inline-flex items-center text-icetex font-bold"
              style={{
                gap: '8px',
                background: 'linear-gradient(135deg, #e8f4ff 0%, #d4e9ff 100%)',
                padding: '10px 20px',
                borderRadius: '25px',
                fontSize: '14px',
                marginBottom: '20px',
                border: '2px solid #b3d9ff',
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              Pregunta {currentQuestionIndex + 1}
            </div>
            <h2
              className="text-texto-oscuro font-bold"
              style={{ fontSize: '1.5rem', lineHeight: '1.5', margin: '0' }}
            >
              {form.questions[currentQuestionIndex].text}
            </h2>
          </div>

          {/* Respuestas */}
          <div style={{ marginBottom: '40px' }}>
            <p
              className="text-texto-sec font-semibold uppercase"
              style={{ fontSize: '15px', marginBottom: '20px', letterSpacing: '0.5px' }}
            >
              Selecciona una respuesta:
            </p>
            <div className="flex flex-col" style={{ gap: '12px' }}>
              {form.questions[currentQuestionIndex].answers.map((answer) => (
                <button
                  // answer-shimmer is kept — defined in index.css with ::before pseudo-element
                  className={`answer-shimmer flex items-center text-texto-oscuro text-left cursor-pointer relative overflow-hidden${selectedAnswer === answer.id ? ' selected' : ''}`}
                  key={answer.id}
                  onClick={() => onSelectAnswer(answer.id)}
                  disabled={isSubmitting}
                  style={
                    selectedAnswer === answer.id
                      ? {
                          gap: '15px',
                          padding: '18px 22px',
                          background: 'linear-gradient(135deg, var(--color-azul-icetex) 0%, #0056b3 100%)',
                          border: '2px solid var(--color-azul-icetex)',
                          borderRadius: '15px',
                          fontSize: '15px',
                          fontWeight: '600',
                          transition: 'all 0.3s ease',
                          color: 'white',
                          boxShadow: '0 6px 20px rgba(0, 63, 129, 0.3)',
                          opacity: isSubmitting ? '0.6' : '1',
                          cursor: isSubmitting ? 'not-allowed' : 'pointer',
                        }
                      : {
                          gap: '15px',
                          padding: '18px 22px',
                          backgroundColor: '#f8fafc',
                          border: '2px solid #e8f0fe',
                          borderRadius: '15px',
                          fontSize: '15px',
                          fontWeight: '600',
                          transition: 'all 0.3s ease',
                          opacity: isSubmitting ? '0.6' : '1',
                          cursor: isSubmitting ? 'not-allowed' : 'pointer',
                        }
                  }
                >
                  <span
                    className="flex items-center justify-center flex-shrink-0"
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      border: '2px solid currentColor',
                      transition: 'all 0.3s ease',
                      ...(selectedAnswer === answer.id
                        ? { backgroundColor: 'white', borderColor: 'white', color: 'var(--color-azul-icetex)' }
                        : {}),
                    }}
                  >
                    {selectedAnswer === answer.id && (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    )}
                  </span>
                  <span className="flex-1" style={{ lineHeight: '1.5' }}>{answer.text}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Navegación */}
          <div
            className="flex justify-between"
            style={{
              gap: '15px',
              paddingTop: '30px',
              borderTop: '2px solid #e8f0fe',
            }}
          >
            {currentQuestionIndex > 0 && (
              <button
                className="border-0 font-bold uppercase cursor-pointer inline-flex items-center justify-center bg-white text-icetex"
                style={{
                  gap: '10px',
                  padding: '16px 32px',
                  borderRadius: '50px',
                  fontSize: '15px',
                  letterSpacing: '0.5px',
                  transition: 'all 0.3s ease',
                  flex: '0 0 auto',
                  border: '2px solid var(--color-azul-icetex)',
                  opacity: isSubmitting ? '0.5' : '1',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                }}
                onClick={() => onNavigate('previous')}
                disabled={isSubmitting}
                onMouseEnter={e => {
                  if (!isSubmitting) {
                    e.currentTarget.style.background = 'var(--color-azul-icetex)';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = '';
                  e.currentTarget.style.transform = 'none';
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                Anterior
              </button>
            )}
            <button
              className="border-0 font-bold uppercase cursor-pointer inline-flex items-center justify-center text-white"
              style={{
                gap: '10px',
                padding: '16px 32px',
                borderRadius: '50px',
                fontSize: '15px',
                letterSpacing: '0.5px',
                transition: 'all 0.3s ease',
                flex: '1',
                background: isLastQuestion
                  ? 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
                  : 'linear-gradient(135deg, var(--color-azul-icetex) 0%, #0056b3 100%)',
                boxShadow: isLastQuestion
                  ? '0 6px 20px rgba(40, 167, 69, 0.3)'
                  : '0 6px 20px rgba(0, 63, 129, 0.3)',
                opacity: (isSubmitting || selectedAnswer === null) ? '0.5' : '1',
                cursor: (isSubmitting || selectedAnswer === null) ? 'not-allowed' : 'pointer',
              }}
              onClick={() => onNavigate('next')}
              disabled={isSubmitting || selectedAnswer === null}
              onMouseEnter={e => {
                if (!isSubmitting && selectedAnswer !== null) {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = isLastQuestion
                    ? '0 8px 25px rgba(40, 167, 69, 0.4)'
                    : '0 8px 25px rgba(0, 63, 129, 0.4)';
                }
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = isLastQuestion
                  ? '0 6px 20px rgba(40, 167, 69, 0.3)'
                  : '0 6px 20px rgba(0, 63, 129, 0.3)';
              }}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="rounded-full animate-spin"
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      borderTopColor: 'white',
                    }}
                  ></span>
                  Enviando...
                </>
              ) : (
                <>
                  {isLastQuestion ? 'Finalizar Diagnóstico' : 'Siguiente'}
                  {!isLastQuestion && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  )}
                  {isLastQuestion && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  )}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Questions;
